import { render, staticRenderFns } from "./UserSearchInput.vue?vue&type=template&id=60894669"
import script from "./UserSearchInput.vue?vue&type=script&lang=js"
export * from "./UserSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/fun_shop_front_05Un/mer_plat_admin/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60894669')) {
      api.createRecord('60894669', component.options)
    } else {
      api.reload('60894669', component.options)
    }
    module.hot.accept("./UserSearchInput.vue?vue&type=template&id=60894669", function () {
      api.rerender('60894669', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/UserSearchInput.vue"
export default component.exports